import PropTypes from "prop-types";

import {
  Stack,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { styled } from "@mui/material/styles";

const APPBAR_MOBILE = 64;

const AppBarRootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: "rgba(249, 250, 251, 0.72)",
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  padding: theme.spacing(0, 5),
}));
type Props = {
  onOpenSidebar: () => void;
};

export const Navbar: React.FC<Props> = ({ onOpenSidebar }) => {
  return (
    <>
      <AppBarRootStyle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <ToolbarStyle>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ color: "#637381" }}
              onClick={onOpenSidebar}
            >
              <MenuIcon />
            </IconButton>
          </ToolbarStyle>
          
        </Stack>
      </AppBarRootStyle>
    </>
  );
};

Navbar.propTypes = {
  onOpenSidebar: PropTypes.func.isRequired,
};
